import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Actividad } from '@interfaces/interface-bakend/ofertas-laborales/actividad.interface';
import { ActividadesService } from '@services/ofertas-laborales/actividades.service';
import { PaisesService } from '@services/shared/paises.service';
import { iconoTramite } from '../../common/helpers/icono-tramite.helper';

@Component({
    selector: 'app-tramites-disponibles',
    templateUrl: './tramites-disponibles.component.html',
    styleUrls: ['./tramites-disponibles.component.scss'],
})
export class TramitesDisponiblesComponent implements OnInit {
    actividades: Actividad[] = [];
    actividadesFiltradas: Actividad[] = [];
    flagLoaded = false;
    textoFiltro = '';

    skeletonItems = [1, 2, 3, 4, 5, 6, 7, 8];

    constructor(
        private router: Router,
        private actividadesService: ActividadesService,
        private paisesService: PaisesService
    ) {}

    async ngOnInit(): Promise<void> {
        await this.getActividadesVigentes();
    }

    async getActividadesVigentes(): Promise<void> {
        this.flagLoaded = false;
        try {
            const actividades = await this.actividadesService.getActividadesVigentes();
            this.actividades = actividades ?? [];
            this.actividadesFiltradas = this.actividades;
        } finally {
            this.flagLoaded = true;
        }
    }

    filtrar(): void {
        const texto = this.textoFiltro.trim().toLowerCase();
        if (!texto) {
            this.actividadesFiltradas = this.actividades;
            return;
        }
        this.actividadesFiltradas = this.actividades.filter((actividad) =>
            [actividad.nombre, actividad.resumenAvatar]
                .filter((valor) => valor != null && valor !== '')
                .join(' ')
                .toLowerCase()
                .includes(texto)
        );
    }

    iconoActividad(actividad: Actividad): string {
        return iconoTramite(actividad);
    }

    seleccionar(actividad: Actividad): void {
        this.actividadesService.setActividadSeleccionada(actividad);
        this.paisesService.setPaisSeleccionado(actividad.paisDisponible);
        this.router.navigate(['/solicitud-tramites']);
    }

    trackByActividad(index: number, actividad: Actividad): string {
        return actividad._id;
    }
}
